import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import Select from "react-select";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import { useGetCustomerSales } from "hooks";

const ChangeSaleForm = props => {
  const {
    isOpenModal,
    toggleModal,
    handleChangeOrderSale,
    isLoadingChangeOrderSale,
    customerId,
  } = props;

  const { t } = useTranslation(["order"]);

  const getInitDefaultValues = () => {
    return {
      sale_id: undefined,
      note: "",
    };
  };

  const schema = yup.object().shape({
    sale_id: yup
      .object()
      .required(t("form.validate.select", { title: t("form.sale") })),
    note: yup
      .string()
      .required(t("form.validate.required", { title: t("form.reason") })),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: getInitDefaultValues(),
  });

  const { data: dataSales, refetch: refetchSaleList } = useGetCustomerSales({
    customerId: customerId,
    params: {
      page: -1,
    },
  });

  useEffect(() => {
    if (!isOpenModal) {
      reset(getInitDefaultValues());
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (isOpenModal && customerId) {
      refetchSaleList();
    }
  }, [isOpenModal, customerId, refetchSaleList]);

  const onSubmit = _values => {
    const data = getValues();

    handleChangeOrderSale({
      sale_id: Number(data.sale_id.value),
      // sale_id: String(data.sale_id.value),
      note: data.note,
    });
  };

  return (
    <React.Fragment>
      <Modal
        size="lg"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>{t("form.change_sale")}</ModalHeader>
        <ModalBody>
          <Row className="row-cols-1">
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="sale_id">
                  {t("form.sale")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="sale_id"
                  render={({ field }) => (
                    <Select
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.sale"),
                      })}
                      options={
                        dataSales?.items?.length > 0
                          ? dataSales.items.map(item => {
                              return {
                                label: `${item?.display_name || ""} ${
                                  item?.username ? `(${item.username})` : ""
                                }`,
                                value: item.id || item.sale_id,
                              };
                            })
                          : []
                      }
                      classNamePrefix="select2-selection"
                      onChange={data => {
                        field.onChange(data);
                      }}
                    />
                  )}
                />
                {errors.sale_id && (
                  <MessageFormValidate error={errors.sale_id.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label htmlFor="note">
                  {t("form.reason")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="note"
                  render={({ field }) => (
                    <Input
                      {...field}
                      type="textarea"
                      className={`form-control ${formValidate(
                        errors,
                        touchedFields,
                        "note"
                      )}`}
                      placeholder={t("placeholder.note")}
                      rows={5}
                    />
                  )}
                />
                {errors.note && (
                  <MessageFormValidate error={errors.note.message} />
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="d-block">
          <Row className="justify-content-end">
            <Col className="col-auto me-auto">
              <Button
                disabled={isLoadingChangeOrderSale}
                color="danger"
                outline
                className="border-0"
                size="xs"
                onClick={toggleModal}
              >
                {t("button.cancel")}
              </Button>
            </Col>
            <Col className="col-auto">
              <Button
                disabled={isLoadingChangeOrderSale}
                size="xs"
                color="primary"
                style={{ backgroundColor: "#3C64B1" }}
                onClick={() => handleSubmit(onSubmit)()}
              >
                {t("button.confirm")}
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

ChangeSaleForm.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleChangeOrderSale: PropTypes.func.isRequired,
  isLoadingChangeOrderSale: PropTypes.bool,
  customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

ChangeSaleForm.defaultProps = {
  isOpenModal: false,
  isLoadingChangeOrderSale: false,
  customerId: null,
};

export default ChangeSaleForm;
